import { render, staticRenderFns } from "./TableInspectCustomNH.vue?vue&type=template&id=61be5244&scoped=true&"
import script from "./TableInspectCustomNH.vue?vue&type=script&lang=js&"
export * from "./TableInspectCustomNH.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectCustomNH.vue?vue&type=style&index=0&id=61be5244&prod&scoped=true&lang=scss&"
import style1 from "./TableInspectCustomNH.vue?vue&type=style&index=1&id=61be5244&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be5244",
  null
  
)

export default component.exports